import { toBN } from './bn';

// this env variable comes from the server
import { NETWORK_NUMBER } from 'core/config';

export const GAS_MARGIN = toBN(1000); // 10% in basis
export const PERCENT = toBN(10000); // 100% in basis

export const chainId = NETWORK_NUMBER ? parseInt(NETWORK_NUMBER, 10) : undefined;

export const PUBLIC_NETWORK = getNetworkName(chainId);

export function getNetworkName(chainId?: number): string {
  switch (chainId) {
    case 1:
      return 'Mainnet';
    case 4:
      return 'Rinkeby';
    case 3:
      return 'Ropsten';
    case 5:
      return 'Goerli';
    case 42:
      return 'Kovan';
    default:
      return 'Unknown';
  }
}
